module.exports = __webpack_public_path__ + "img/symbol_10.2f3db111.png";